class WhatsAppService {
  unsupported(kind) {
    const error = new Error(
      `${kind} WhatsApp is no longer sent through smsmenow. Invoice PDFs go through CallDesk from invoice history.`
    );
    console.warn(error.message);
    throw error;
  }

  async sendTextMessage() {
    this.unsupported("Text");
  }

  async sendMediaMessage() {
    this.unsupported("Media");
  }

  async sendJsonMessage() {
    this.unsupported("Bulk");
  }

  async sendBulkMessages() {
    return this.sendJsonMessage();
  }

  async sendDietChartNotification() {
    this.unsupported("Diet chart");
  }

  async sendInvoiceNotification() {
    this.unsupported("Invoice");
  }

  async sendDietReminder() {
    this.unsupported("Diet reminder");
  }

  async sendPaymentReminder() {
    this.unsupported("Payment reminder");
  }

  async getBalance() {
    this.unsupported("Balance check");
  }

  setAuthKey() {
    // CallDesk auth lives on Cloud Functions, not in the browser.
  }
}

export const whatsappService = new WhatsAppService();
export default whatsappService;
